export default __webpack_public_path__ + "static/media/36I-102798_-15978_0.18807a25.jpg";